/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ /* eslint-disable no-unused-vars */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/prop-types */ import React, {
  useContext,
} from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import GetApp from '@material-ui/icons/GetApp';

import { BillsTableRow } from './BillsTableRow';
import api from '../../../service/axios/api';
import FlashContext from '../../../components/contexts/FlashContext';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#303474',
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

// eslint-disable-next-line import/prefer-default-export
export function BillsTable({
  docs,
  page,
  setPage,
  itens,
  setItens,
  total,
  searchData,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { notifyError } = useContext(FlashContext);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(event.target.value);
  };

  const getXls = async () => {
    try {
      const { data } = await api.billsToPay.getPendingXls();
      const url = data.retorno.link;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'pendentes.xlsx');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => {
          notifyError(err.msg);
        });
      } else {
        notifyError(error.message);
      }
    }
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                {t('billsToPay.table.supplier')}
              </StyledTableCell>
              <StyledTableCell>{t('billsToPay.table.center')}</StyledTableCell>
              <StyledTableCell>
                {t('billsToPay.table.category')}
              </StyledTableCell>
              <StyledTableCell>{t('billsToPay.table.dueDate')}</StyledTableCell>
              <StyledTableCell>
                {t('billsToPay.table.payingMethod')}
              </StyledTableCell>
              <StyledTableCell>{t('billsToPay.table.status')}</StyledTableCell>
              <StyledTableCell>{t('billsToPay.table.obs')}</StyledTableCell>
              <StyledTableCell>Tipo</StyledTableCell>
              <StyledTableCell>Valor Previsto</StyledTableCell>
              <StyledTableCell>Valor Realizado</StyledTableCell>
              <StyledTableCell>Nº NFe</StyledTableCell>
              <StyledTableCell>Data Emissão</StyledTableCell>
              <StyledTableCell>Conta Bancária</StyledTableCell>
              <StyledTableCell>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  {t('billsToPay.table.createdAt')}
                  <GetApp onClick={getXls} style={{ cursor: 'pointer' }} />
                </div>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {docs.map(row => {
              return (
                <BillsTableRow
                  key={row.id}
                  docs={row}
                  searchData={searchData}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100, 1000, 50000]}
        component="div"
        count={total}
        rowsPerPage={itens}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
